import { useEffect, useRef } from "react";
import { authApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// One-time exchange of the OAuth session_id (URL fragment) for a session.
// The session-data call is made from OUR backend, never here.
export default function AuthCallback() {
  const done = useRef(false);
  const { applySession } = useAuth();

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      try {
        if (!sid) throw new Error("missing session id");
        const { data } = await authApi.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sid } }
        );
        applySession(data);
        if (data?.phone) localStorage.setItem("bk_loyalty_phone", data.phone);
      } catch {
        /* fall through — user lands on home, can retry sign-in */
      }
      // Strip the fragment then hand off to the storefront (full reload so the
      // provider re-reads the freshly-set cookie).
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      window.location.replace("/");
    })();
  }, [applySession]);

  return (
    <div
      className="min-h-[100dvh] flex flex-col items-center justify-center bg-stone-100 gap-3"
      data-testid="auth-callback-screen"
    >
      <Loader2 className="w-8 h-8 text-brand-red animate-spin" />
      <div className="font-display text-2xl text-brand-red">Signing you in…</div>
    </div>
  );
}
